module.exports = __webpack_public_path__ + "media/images/logos/glinblack-logo-mockup-card-66249ac5f90c418483984f33353cbfbe.svg";